export default __webpack_public_path__ + "static/cover-6112882cb2aad6bdb6eca4e87e36f217.png";